import { Chip } from './primitives/Chip';
import { Section } from './primitives/Section';
import { CheckRow } from './primitives/CheckRow';
import { MonoKicker } from './primitives/MonoKicker';

const audiences = [
    'Primary care',
    'Sub-specialists',
    'Midwifery',
    'Home & telehealth visits',
    'Locums & moonlighting',
];

const startingOut = [
    'Documentation handled from your first visit',
    'A chart, without an EMR contract',
    'Scheduling and outreach wired up for you',
    'Scales with the panel, not ahead of it',
];

export function AudienceSection() {
    return (
        <Section className="border-b border-border">
            <div className="flex flex-col gap-12">
                <div className="flex max-w-2xl flex-col gap-4">
                    <MonoKicker data-reveal>Who we work with</MonoKicker>
                    <h2
                        data-reveal
                        className="font-display text-[clamp(30px,4vw,40px)] leading-[1.15] text-balance"
                    >
                        If you see clients, it fits.
                    </h2>
                    <p
                        data-reveal
                        className="text-[clamp(16px,1.4vw,18px)] leading-[1.55] text-muted-foreground"
                    >
                        Mohair doesn&rsquo;t much care what&rsquo;s on your
                        badge. What matters is that there&rsquo;s a
                        documentation load and an operations load, and neither
                        is what you trained for.
                    </p>
                </div>

                <div data-reveal className="flex flex-wrap gap-4">
                    {audiences.map((label) => (
                        <Chip key={label} dot>
                            {label}
                        </Chip>
                    ))}
                </div>

                <div
                    data-reveal
                    className="grid grid-cols-[repeat(auto-fit,minmax(min(320px,100%),1fr))] gap-12 rounded-[16px] border border-border bg-card p-[clamp(24px,4vw,48px)]"
                >
                    <div className="flex flex-col gap-6">
                        <MonoKicker className="text-primary">
                            Particularly good at one thing
                        </MonoKicker>
                        <h3 className="font-display text-[clamp(26px,3vw,40px)] leading-[1.15]">
                            Starting something of your own?
                        </h3>
                        <div className="flex flex-col gap-4 text-[16px] leading-[1.55] text-muted-foreground">
                            <p>
                                More clinicians are opening small independent
                                practices every year — a few consults a week
                                alongside the day job, or a panel they finally
                                got to choose. You get the clinical part right
                                immediately. The operations are the part nobody
                                trained you for, and there&rsquo;s no practice
                                manager to hand them to.
                            </p>
                            <p>
                                That&rsquo;s the gap we fill. You bring the
                                medicine; we bring the back office.
                            </p>
                        </div>
                    </div>

                    <div className="flex flex-col justify-center gap-4">
                        {startingOut.map((line) => (
                            <CheckRow key={line}>{line}</CheckRow>
                        ))}
                    </div>
                </div>
            </div>
        </Section>
    );
}
